import React, { useState, useEffect } from "react";
import { TextField, Card, CardContent } from "@mui/material";
import SriyanshCardHeader from "../../components/CardHeader";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);

  // Function to fetch roles from the API
  const fetchRoles = async () => {
    try {
      const response = await apiClient.post("/roleList", {
        /* request payload if needed */
      });
      setRoles(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const [fname, setfName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const [updatebtn, setUpdateBtn] = useState(true);

  const navigate = useNavigate();
  //let userName ="";
  const handleClose = () => {
    navigate("../", { replace: true });
  };

  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getUserData = async () => {
    try {
      const response = await apiClient.post("/getUserData", {
        uname: logineuname,
        userName1: username,
        /* request payload if needed */
      });
      const data = response.data[0];
      setEmail(data.emailid);
      setMobileNumber(data.mobilenumber);
      setfName(data.FullName);
      setRole(data.userrights);
      setconsignee(data.consignee);
      setPassword("");
      setUpdateBtn(false);
    } catch (error) {
      setfName("");
      setEmail("");
      setPassword("");
      setMobileNumber("");
      setUpdateBtn(true);
      if (error.response) {
        // Server responded with a status other than 200 range
        // console.log('Error data:', error.response.data);
        //console.log('Error status:', error.response.status);
        // console.log('Error headers:', error.response.headers);
      } else if (error.request) {
        // No response received
        // console.log('No response:', error.request);
      } else {
        // Request setup triggered an Error
        // console.log('Error', error.message);
      }
      // console.log(error.config);
    }
  };

  useEffect(() => {
    fetchConsignees();
    fetchRoles();
  }, []);

  useEffect(() => {
    if (consignees.length > 0) {
      setconsignee(consignees[0].ConsigneeCode);
    }

    if (roles.length > 0) {
      setRole(roles[2].id);
    }
  }, [consignees, roles, username]);

  useEffect(() => {}, [updatebtn]);

  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setMobileNumber(value);
    }
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const UpdatOldUser = async (e) => {
    e.preventDefault();

    let formErrors = {};
    if (!fname) formErrors.name = "Name is required";
    if (!email) formErrors.email = "Email is required";

    if (!username) formErrors.username = "Username is required";
    if (!mobileNumber) formErrors.mobileNumber = "Mobile number is required";
    if (mobileNumber && mobileNumber.length !== 10)
      formErrors.mobileNumber = "Mobile number must be 10 digits";
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailPattern.test(email)) {
      formErrors.email = "Email is invalid";
    }

    setErrors(formErrors);

    //console.log(username);

    if (Object.keys(formErrors).length === 0) {
      apiClient
        .post("/changepassword", {
          uname: username,
          pastext: password,
          ipp: ip,
        })
        .then(function (response) {
          setErrors(response.data);

          setfName("");
          setEmail("");
          setPassword("");
          setUsername("");
          setPassword("");
          setMobileNumber("");
          //   if (roles.length > 0) {
          //     setRole(roles[2].role);
          //   }
        })
        .catch(function (error) {
          setErrors(error.data);
        });
    }
  };

  return (
    <div >
      {/* <SriyanshCardHeader Title="Reset User Password" /> */}
      <Card className="Formcard ">
      <div className="input-groupHeading">
      Reset User Password

            </div>
        <CardContent>
          <div className="row">
          <div className="container">
            <div className="input-group">
              <TextField
                label="User ID"
                size="small"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getUserData();
                  }
                }}
                fullWidth
                error={!!errors.username}
                helperText={errors.username}
                inputProps={{ maxLength: 10 }}
              />
            </div>

            <div className="input-group">
              <TextField
                label="Email"
                size="small"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                inputProps={{ maxLength: 50 }}
                disabled="true"
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <TextField
                label="Full Name"
                size="small"
                variant="outlined"
                value={fname}
                onChange={(e) => setfName(e.target.value)}
                fullWidth
                error={!!errors.fname}
                helperText={errors.fname}
                inputProps={{ maxLength: 30 }}
                disabled="true"
              />
            </div>

            <div className="input-group">
              <TextField
                label="Password"
                variant="outlined"
                size="small"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                error={!!errors.password}
                helperText={errors.password}
                inputProps={{ maxLength: 15 }}
              />
            </div>
          </div>

          <div className="container">
            <div className="input-group">
              <TextField
                label="Mobile Number"
                variant="outlined"
                type="tel"
                size="small"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                fullWidth
                error={!!errors.mobileNumber}
                helperText={errors.mobileNumber}
                inputProps={{ maxLength: 10, pattern: "[0-9]*" }}
                disabled="true"
              />
            </div>

            <div className="input-group">
              <DropdownfromDatabaseList
                Options={roles} //ARRAY COMPONENT
                option={role} // VALUE VARIABLE
                setOptionValue={setRole} //SET VALUE VARIBALE
                DisplayItem1="role"
                DisplayItem2="id"
                size="small"
                // showKeyInLabel={true}
                disabled="true"
              />
            </div>
          </div>

          {role === 2 && (
            <div className="container">
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={consignees}
                  size="small"
                  option={consignee}
                  setOptionValue={setconsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                  disabled="true"
                />
              </div>
            </div>
          )}

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={UpdatOldUser}
                title="Click for user update"
                disabled={updatebtn}
              >
                Reset Password
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default ResetPassword;
